import { Component, useEffect, useState, type ReactNode, type ButtonHTMLAttributes } from 'react';
import { showNotice } from '../app/notice';

export function Icon({ name }: { name: string }) { return <i aria-hidden="true" className={`fa-solid fa-${name}`} />; }
export function Empty({ children }: { children: ReactNode }) { return <div className="empty card">{children}</div>; }
export function AsyncButton({ action, children, ...props }: Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> & { action: () => Promise<unknown> }) {
  const [busy, setBusy] = useState(false); const [error, setError] = useState('');
  return <><button {...props} disabled={busy || props.disabled} onClick={() => {
    if (busy) return;
    setBusy(true); setError('');
    void action().catch(error => setError(error instanceof Error ? error.message : '操作失敗')).finally(() => setBusy(false));
  }}>{busy ? '處理中…' : children}</button>{error ? <p role="alert" className="error">{error}</p> : null}</>;
}
export function StarButton({ starred, action, label = '星號', onError, disabled }: {
  starred: boolean; action: (next: boolean) => Promise<unknown>; label?: string;
  onError?: (message: string) => void; disabled?: boolean;
}) {
  const [selected, setSelected] = useState(starred);
  useEffect(() => setSelected(starred), [starred]);
  return <button className={`icon-button ${selected ? 'star' : ''}`} aria-label={label}
    aria-pressed={selected} disabled={disabled} onClick={() => {
      const next = !selected;
      setSelected(next);
      void action(next).catch(error => onError?.(error instanceof Error ? error.message : '星號會在背景重試同步'));
    }}><Icon name="star" /></button>;
}
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: string }> {
  state = { error: '' };
  static getDerivedStateFromError(error: Error) { return { error: error.message }; }
  render() { return this.state.error ? <main className="empty"><h1>畫面暫時無法載入</h1><p role="alert">{this.state.error}</p><button onClick={() => location.reload()}>重新開啟</button></main> : this.props.children; }
}
export function speak(text: string, locale = 'en-US'): void {
  if (typeof window.speechSynthesis === 'undefined') { showNotice('此瀏覽器目前無法播放發音'); return; }
  const audioSession = (navigator as Navigator & { audioSession?: { type: string } }).audioSession;
  if (audioSession) audioSession.type = 'playback';
  window.speechSynthesis.cancel(); const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = locale; utterance.rate = 0.85; window.speechSynthesis.speak(utterance);
}
export function cancelSpeech(): void { if ('speechSynthesis' in window) window.speechSynthesis.cancel(); }
export function vibrate(pattern: number | number[] = 12): void {
  if ('vibrate' in navigator) navigator.vibrate(pattern);
}
